module.exports = __webpack_public_path__ + "img/stt-del.bef6dcf8.svg";